import moment                       from 'moment';
import classNames                   from 'classnames';
import React, { FC, ReactNode }     from 'react';
import { Label, Popup, PopupProps } from 'semantic-ui-react';
import _                            from 'underscore';

import { Align, CorvalAccountLike, CorvalAuditEntry } from '../../../types';
import { TimeService }                                from '../../../services';
import { StyledContainer }                            from '../../containers';
import { Cell, Grid }                                 from 'styled-css-grid';
import { AccountUser }                                from '../user/AccountUser';
import { UserAvatar }                                 from '../user-avatar/UserAvatar';


interface Props {
    records: Array<Pick<CorvalAuditEntry, 'accountId' | 'timestampUtc'>>,
    usePopup?: boolean,
    useIcon?: boolean,
    useAvatar?: boolean,
    statement?: ( user: CorvalAccountLike, timestamp: string, statement: string ) => ReactNode,
    popupProps?: PopupProps,
}

const defaultProps: Props = {
    records:    [],
    usePopup:   true,
    useIcon:    true,
    useAvatar:  false,
    statement:  null,
    popupProps: {},
}

const LastUpdatedAuditTag: FC<Props> = ( props ) => {

    if( _.isEmpty( props.records ) ) return null;

    let records                  = _.mapObject( props.records, record => ( { ...record, timestamp: TimeService.ISOtoMoment( record.timestampUtc ) } ) ),
        maxTimestamp             = _.isEmpty( _.values( records ) ) ? null : moment.max( _.pluck( records, 'timestamp' ) ),
        recordsWithmMaxTimestamp = _.findWhere( records, { timestamp: maxTimestamp } );

    if( _.isEmpty( maxTimestamp ) ) return null;

    let timestamp = TimeService.asDisplayDate( maxTimestamp ),
        statement = `Last updated ${ timestamp }`;

    return (

        <Popup
            position={ 'top center' }
            disabled={ !props.usePopup }
            size={ 'small' }
            content={ (
                <StyledContainer textAlign={ Align.LEFT }>
                    { props.children }
                </StyledContainer>
            ) }
            trigger={ (

                <AccountUser accountId={ recordsWithmMaxTimestamp.accountId } loadingLabel={ '' }>

                    { ( user: CorvalAccountLike ) =>

                        <Label basic circular
                               color={ 'grey' }
                               size={ 'tiny' }
                               className={ classNames( { 'cursor--pointer': props.usePopup }, 'display--inline-block' ) }
                               icon={ ( props.useAvatar || !props.useIcon ) ? null : 'user' }
                               content={ !props.useAvatar ? <>{ _.isFunction( props.statement ) ? props.statement( user, timestamp, statement ) : statement }</> : (
                                   <Grid columns={ `auto auto` } rows={ `auto` } columnGap={ `4px` } style={ { margin: `-3px 0px -3px -3px` } }>

                                       <Cell middle center>
                                           <UserAvatar user={ user } asInitials={ true } size={ 'nano' } rounded={ true }/>
                                       </Cell>
                                       <Cell middle>{ _.isFunction( props.statement ) ? props.statement( user, timestamp, statement ) : statement }</Cell>
                                   </Grid>
                               ) }
                        /> }

                </AccountUser>
            ) }
            { ...props.popupProps }/>
    );
};

LastUpdatedAuditTag.defaultProps = defaultProps;

export { LastUpdatedAuditTag }
